<template>
  <div class="mine-page">
    <div class="header">
      <UserCard
        :role="USER_ROLES.REGION_MANAGER"
        :user="user"
        :store="currentStore"
      />
    </div>
    <div>
      <CCell title="区域" :value="user.regionName" />
    </div>
  </div>
</template>

<script>
import CCell from "@/components/common/CCell.vue";
import UserCard from "@/components/common/UserCard.vue";
import { USER_ROLES } from "@/consts";
import normalPage from "@/mixins/normal-page";
import { mapGetters, mapState } from "vuex";

export default {
  mixins: [normalPage],
  components: { UserCard, CCell },
  data() {
    return { USER_ROLES };
  },
  computed: {
    ...mapState(["account", "user"]),
    ...mapGetters(["currentStore"]),
  },
  watch: {
    "account.role": {
      deep: true,
      handler(role) {
        console.log("role", role);
        if (role === USER_ROLES.CLIENT_AGENT) {
          this.$router.replace({ name: "SAMy" });
        } else if (role === USER_ROLES.STORE_MANAGER) {
          this.$router.replace({ name: "StoreManagerMy" });
        }
      },
    },
  },
};
</script>

<style lang="less" scoped>
.mine-page {
  width: 100vw;
  height: 100%;
  background-color: #fff;
}

.header {
  width: 100vw;
  height: 328/20rem;
}
</style>
